const comprobante = {
  readComprobanteTipos: 'comprobantes-tipo/{{pais}}',
  readComprobante: 'comprobante/{{uuid_pago}}',
  readComprobantePdf: 'comprobante/{{uuid_pago}}/pdf'
}

export default comprobante
